import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { ApplicationState } from 'state/store/configureStore';
import { WaitlistSubscription } from 'state/types';

export const FEATURE_NAME = `waitlist-subscription-status`;

const adaptor = createEntityAdapter<WaitlistSubscription>({
  selectId: (m) => m.stateCode,
});

const slice = createSlice({
  name: FEATURE_NAME,
  initialState: adaptor.getInitialState(),
  reducers: {
    upsertSubscriptionStatus: adaptor.upsertOne
  },
});

export const { upsertSubscriptionStatus } = slice.actions;

export const {
  selectById: selectSubscriptionStatusByStateCode,
} = adaptor.getSelectors<ApplicationState>(state => state.waitlistSubscriptionState);

export const waitlistSubscriptionReducer = slice.reducer;
